// Use $ instead of $uery without replacing global $
(function ($) {

    $(document).ready(function () {
        var slideSingle = $('body .generic-reference-slider .slider-wrap .item').length;
        $('body .generic-reference-slider .slider-wrap .item .img-wrap .bg-img').addClass('wow fadeInDown');
        $('body .generic-reference-slider .slider-wrap .item .col-wrap').addClass('wow fadeInUp');
        $('body .generic-reference-slider.news-ref-slider .slider-wrap .item .img-wrap .bg-img').addClass('wow fadeInDown').attr("data-wow-delay","0.4s");
        $('body .generic-reference-slider.news-ref-slider .slider-wrap .item .col-wrap').addClass('wow fadeInUp').attr("data-wow-delay","0.4s");

        $('.generic-reference-slider .slider-wrap .slider').slick({
            draggable: true,
            autoplay: true,
            autoplaySpeed: 9000,
            arrows: false,
            dots: true,
            fade: true,
            speed: 1000,
            pauseOnFocus: false,
            pauseOnHover: false,
            dotsClass: 'custom-dots',
            infinite: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });
        if (slideSingle <= 1) {
            $('body .generic-reference-slider .slider-wrap .custom-dots').hide();
        } else {
            $('body .generic-reference-slider .slider-wrap .custom-dots').show();
        }
    });
    $(window).on("load",function () {
        setTimeout(function () {
            if($('body .generic-reference-slider.news-ref-slider .col-wrap').css('visibility')==='visible'){
                $('body .generic-reference-slider.news-ref-slider .custom-dots').css({"visibility":"visible"});
            }
        },1200);
    });
    $(window).on("scroll",function () {
        if($('body .generic-reference-slider.news-ref-slider .parallax-move-right').hasClass('undefined')){
            $('body .generic-reference-slider.news-ref-slider .custom-dots').css({"visibility":"visible"});
        }
    });

    $(window).resize(function () {
        var slideSingle = $('body .generic-reference-slider .slider-wrap .item').length;

        if (slideSingle <= 1) {
            $('body .generic-reference-slider .slider-wrap .custom-dots').hide();
        } else {
            $('body .generic-reference-slider .slider-wrap .custom-dots').show();
        }
    });
})(jQuery);


